document.addEventListener("DOMContentLoaded", function () {
  if (typeof jQuery !== "undefined" && typeof jQuery.fn.lightzoom !== "undefined") {
    // Select only main product images (exclude video/3D poster images)
    jQuery('.product-media__image.image-selector').lightzoom({
      zoomPower: 3,
      glassSize: 200
    });
  } else {
    console.warn("LightZoom or jQuery not loaded properly.");
  }
});

